import { render, staticRenderFns } from "./MainChartIndicators.vue?vue&type=template&id=6b84a8f4&scoped=true&"
import script from "./MainChartIndicators.vue?vue&type=script&lang=js&"
export * from "./MainChartIndicators.vue?vue&type=script&lang=js&"
import style0 from "./MainChartIndicators.vue?vue&type=style&index=0&id=6b84a8f4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b84a8f4",
  null
  
)

export default component.exports